var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      staticClass: "page-dialog",
      attrs: {
        title: "批量导入游戏",
        visible: _vm.isVisible,
        width: "500px",
        "close-on-click-modal": false,
      },
      on: { closed: _vm.handleDialogClosed, close: _vm.handleCancel },
    },
    [
      _c(
        "div",
        { staticClass: "import-container" },
        [
          _c(
            "el-upload",
            {
              staticClass: "upload-demo",
              attrs: {
                action: "#",
                "on-change": _vm.handleFileChange,
                "before-upload": _vm.beforeUpload,
                "auto-upload": false,
                "file-list": _vm.fileList,
                limit: 1,
                "on-exceed": _vm.handleExceed,
                drag: "",
              },
            },
            [
              _c("i", { staticClass: "el-icon-upload" }),
              _c("div", { staticClass: "el-upload__text" }, [
                _vm._v(" 将文件拖到此处，或 "),
                _c("em", [_vm._v("点击上传")]),
              ]),
              _c(
                "div",
                {
                  staticClass: "el-upload__tip",
                  attrs: { slot: "tip" },
                  slot: "tip",
                },
                [_vm._v(" 支持 xlsx、xlsm 格式的文件，单个文件大小不超过 10M ")]
              ),
            ]
          ),
          _c(
            "div",
            {
              staticClass: "template-download",
              staticStyle: { "margin-top": "20px" },
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: { click: _vm.handleDownloadTemplate },
                },
                [_vm._v("下载游戏模板")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "template",
        { slot: "footer" },
        [
          _c(
            "el-button",
            { attrs: { size: "small" }, on: { click: _vm.handleCancel } },
            [_vm._v("取消")]
          ),
          _c(
            "el-button",
            {
              attrs: {
                type: "primary",
                size: "small",
                loading: _vm.loading,
                disabled: _vm.fileList.length === 0,
              },
              on: { click: _vm.handleConfirm },
            },
            [_vm._v("确定")]
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }